export const getProcessor = (currentProcessor: string) => {
  switch (currentProcessor) {
    case 'STRIPE_PROCESSOR':
      return 'stripe';
    case 'JUSTIFI_PROCESSOR':
      return 'justifi';
    default:
      return 'stripe';
  }
};
